export const version = 'kunde-v1.20.0-SNAPSHOT-dac6be109857ebdfee40d9b4b4fa3ccf6928bf06';